import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Select from 'components/@common/Inputs/Select';
import { useField } from 'formik';
import cx from 'clsx';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import GridOnIcon from '@material-ui/icons/GridOn';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import { ReportView } from '../../../types';

const useStyles = makeStyles(theme => {
  return {
    container: {
      [theme.breakpoints.up('lg')]: {
        position: 'sticky'
      },
      zIndex: 100,
      top: 0,
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(3),
      boxShadow: theme.shadows[2],
      background: 'white'
    },
    buttonContainer: {
      height: '100%',
      alignContent: 'flex-end',
      marginTop: '-3px'
    },
    label: {
      fontWeight: 600
    },
    iconButton: {
      width: 36,
      height: 36,
      minWidth: 'unset',
      padding: 'unset'
    },
    iconButtonSelected: {
      backgroundColor: `${theme.palette.secondary.main} !important`
    },
    icon: {
      height: 18,
      width: 18
    },
    iconSelected: {
      color: 'white'
    }
  };
});

type Props = {
  name?: string;
} & React.ComponentProps<typeof Select>;

const ViewAsSwitch: React.FC<Props> = ({ name = 'viewAs' }) => {
  const classes = useStyles();
  const { t } = useTranslation('Reports');
  const [field, , { setValue }] = useField(name);
  const viewAs = field.value;

  const handleChangeView = (e: React.MouseEvent<HTMLButtonElement>): void =>
    setValue(e.currentTarget.value);

  return (
    <Grid
      container
      direction="column"
      alignContent="center"
      justify="center"
      className={classes.buttonContainer}
    >
      <Grid item>
        <Typography variant="body1" className={classes.label}>
          View As
        </Typography>
      </Grid>
      <Grid item container spacing={1}>
        <Grid item>
          <Tooltip title={t('Graphs')}>
            <Button
              variant="outlined"
              size="small"
              color="secondary"
              disableElevation
              value="chart"
              onClick={handleChangeView}
              className={cx(classes.iconButton, {
                [classes.iconButtonSelected]: viewAs === ReportView.CHART
              })}
            >
              <ShowChartIcon
                className={cx(classes.icon, {
                  [classes.iconSelected]: viewAs === ReportView.CHART
                })}
              />
            </Button>
          </Tooltip>
        </Grid>
        <Grid item>
          <Tooltip title={t('Tables')}>
            <Button
              variant="outlined"
              size="small"
              color="secondary"
              disableElevation
              value="table"
              onClick={handleChangeView}
              className={cx(classes.iconButton, {
                [classes.iconButtonSelected]: viewAs === ReportView.TABLE
              })}
            >
              <GridOnIcon
                className={cx(classes.icon, {
                  [classes.iconSelected]: viewAs === ReportView.TABLE
                })}
              />
            </Button>
          </Tooltip>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ViewAsSwitch;
